import { WebchatTactfulEventsNames, WebchatEvents } from './bus-events';
import bugsnagClient from "@/utilities/bugsnag";
import { WebchatMessage } from './WebchatClient';
import { WebchatEventEmmitter } from './WebchatEventEmmitter';
import { io, Socket } from "socket.io-client";

/**
 * Responsible for communicating with the Webchat backend.
 * 
 * Handles the following interactions between widget and server:
 * - Sending REST requests
 * - Opening the realtime connection to BE using Socket.io
 * - Triggering callbacks in widget on events received from socket
 */
export class WebchatServer {
    socket: Socket = null;
    reconnect_timeout: number = 3000;
    guid: string = null;

    async request(url: string) {
      let response = await fetch(url, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      let message = await response.json();
      return message;
    }

    async requestWithHeaders(url: string, Headers:any ) {
      let response = await fetch(url, {
        method: "GET",
        headers: Headers,
      });
      let message = await response.json();
      return message;
    }

    sendMessage(message: WebchatMessage) {
      this.socket.send(JSON.stringify(message));
    }

  /**
   * Sends an event to Webchat's back end server. Appends the event name and a flag
   * indicating that this event is meant for Redis and isn't a WebchatMessage
   * as the socket usually expects.
   * 
   * 
   * @param name 
   * @param payload 
   */
  async sendEvent<T extends WebchatTactfulEventsNames>(
    name: T,
    payload: WebchatEvents[T],
  ) {
    const event = JSON.stringify({
      name,
      isRedisEvent: true,
      ...payload,
    });

    this.socket.send(event);
  }

    async coreApiRequest(url: string, method: string, headers:any, body?:any ) {
      let response = await fetch(url, {
        method: method,
        headers: headers,
        body: body,
        mode: 'cors'
      });
      return response;
    }

    /**
     * Connects using Socket.io to `ws_url` (Webchat BE)
     * 
     * Emits the following connection events to `_listener`
     * - connect
     * - disconnect
     * - close
     * - message
     * - socket_error
     */
    connectWebsocket(ws_url: string, _listener: WebchatEventEmmitter) {
      this.socket = io(ws_url, {
        reconnection: true,
        reconnectionDelay: 5000
      });

      this.socket.on("connect", () => {
        console.log("socketio connection: connect",this.socket.connected, this.socket);
        _listener.emit('connected', "");
      });

      this.socket.on("disconnect", (reason:any) => {
        _listener.emit('disconnected', reason);
        console.log("socketio connection: disconnect",this.socket, reason);
      });

      this.socket.on('close', (event:any)=>{
        console.log("socketio connection: close",this.socket.connected, event);
        _listener.emit('disconnected', event);
      });
      
      this.socket.on('message',  (event:any) => {
        let message = null;
        try {
          message = JSON.parse(event);
        } catch (err) {
          _listener.emit('socket_error', err);
          bugsnagClient.notify(err as any);
          return;
        }
        _listener.emit(message.type, message);
      });

      // TODO: is this correct ?
      this.socket.on('lang_update', (event:any) => {        
        let lang = null;
        try {
          lang = JSON.parse(event);
        } catch (err) {
          _listener.emit('socket_error', err);
          bugsnagClient.notify(err as any);
          return;
        }
        _listener.emit('lang_updated', lang);
      });
    }
    closeWebsocket(){
      this.socket.disconnect();
    }
  }
